type BackArrowIconProps = {
  className?: string;
};

export const BackArrowIcon = ({ className }: BackArrowIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="57px"
    height="45px"
    viewBox="0 0 55 40"
    className={className}
    aria-hidden
  >
    <path
      fill="#006FE4"
      fillRule="evenodd"
      d="M27 12h28v16H27v12L0 20 27 0v12z"
    />
  </svg>
);
